/**
 * Script Generation input contract SoT
 * (VISTOERA_PC2_SCRIPT_GENERATION_REQUIRED_INPUT_READINESS_PREFLIGHT_AND_NO_DISPATCH_ON_INVALID_P0_V2).
 *
 * Aligns with skill ``script_generation/v1/input.schema.json`` plus product UX:
 * tenants never fill SYSTEM_REQUIRED fields; USER_OPTIONAL may be empty.
 */

export const SCRIPT_GENERATION_DEFAULT_CONTENT_TYPE = '广告剧本'
export const SCRIPT_GENERATION_DEFAULT_TARGET_DURATION_SEC = 30

/** USER_REQUIRED — must be present (or defaulted into node state) before Generate. */
export const SCRIPT_GENERATION_USER_REQUIRED_FIELDS = [
  'scriptSourceContext', // canonical script source (maps to creative_context.title + premise)
  'contentType',
  'targetDurationSeconds',
] as const

/** USER_OPTIONAL — empty must NOT block Generate. */
export const SCRIPT_GENERATION_USER_OPTIONAL_FIELDS = [
  'scriptStructure',
  'generationRequirements',
  'additionalRequirements',
  'supportingAssets',
] as const

/** SYSTEM_REQUIRED — injected by request builder / backend; never tenant UI. */
export const SCRIPT_GENERATION_SYSTEM_REQUIRED_FIELDS = [
  'schema_version',
  'script_count',
  'skill',
  'skill_version',
] as const

export function normalizeScriptGenerationFieldDefaults(fields: Record<string, unknown>): {
  contentType: string
  targetDurationSeconds: number
} {
  const fromScriptSource = fields.scriptSourceContext as { estimatedDuration?: number | null } | null | undefined
  const creative =
    fromScriptSource ??
    ((fields.creativeContext as { estimatedDuration?: number | null } | null) ?? null)
  const contentType =
    typeof fields.contentType === 'string' && fields.contentType.trim()
      ? fields.contentType.trim()
      : SCRIPT_GENERATION_DEFAULT_CONTENT_TYPE
  const fromField =
    typeof fields.targetDurationSeconds === 'number' && Number.isFinite(fields.targetDurationSeconds)
      ? Math.round(fields.targetDurationSeconds)
      : null
  const fromCreative =
    typeof creative?.estimatedDuration === 'number' && Number.isFinite(creative.estimatedDuration)
      ? Math.round(creative.estimatedDuration)
      : null
  const targetDurationSeconds = fromField && fromField > 0 ? fromField : fromCreative && fromCreative > 0 ? fromCreative : SCRIPT_GENERATION_DEFAULT_TARGET_DURATION_SEC
  return { contentType, targetDurationSeconds }
}
